import React from "react";
import ReactDOM from "react-dom";
import { appName } from "../../../utils";
import sdpLogoPurple2 from "../../../assets/images/appLogo/sdpLogoPurple2.svg";
import sikkaPrimeLogoPurpleBg from "../../../assets/images/appLogo/sikkaPrimeLogoPurpleBg.svg";

function LazyLoader() {
    return ReactDOM.createPortal(
        <div
            style={{
                position: "fixed",
                width: "100%",
                height: "100%",
                top: 0,
                right: 0,
                backgroundColor: "rgba(236, 234, 234, 0.9)",
                zIndex: 1000,
                opacity: 0.5,
            }}
            className="d-flex flex-column justify-content-center align-items-center"
        >
            <img
                src={
                    appName === "Self-Driving Practice"
                        ? sdpLogoPurple2
                        : sikkaPrimeLogoPurpleBg
                }
                alt={appName}
                style={{ width: "min(200px, 50%)" }}
            />
            <h1 className="fs-4 mt-2">Loading...</h1>
        </div>,
        document.getElementById("page-load-mask")
    );
}

export default LazyLoader;
